module.exports = __webpack_public_path__ + "static/media/logo_qualdo-mqx-light.a9f7c32a.svg";